import WoSectionCard from "../common/WoSectionCard";
import History from "./history";

// History section as an independent card matching the proposals/forms look.
function WoHistory({ woId }) {
  return (
    <WoSectionCard title="History">
      <History woId={woId} />
    </WoSectionCard>
  );
}

export default WoHistory;
